class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.clearButton = this.querySelector('.search__clear');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      
      // Setup clear button functionality
      if (this.clearButton) {
        this.setupClearButton();
      }
    }
  }

  setupClearButton() {
    // Show/hide clear button based on input value
    const toggleClearButton = () => {
      if (this.input.value.trim().length > 0) {
        this.clearButton.hidden = false;
      } else {
        this.clearButton.hidden = true;
      }
    };

    // Check on initialization
    toggleClearButton();

    // Show clear button when typing
    this.input.addEventListener('input', toggleClearButton);

    // Clear the input when button is clicked
    this.clearButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.input.value = '';
      this.clearButton.hidden = true;
      this.input.focus();
      
      // Trigger input event to update predictive search
      this.input.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event?.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      
      // Hide clear button when form is reset
      if (this.clearButton) {
        this.clearButton.hidden = true;
      }
    }
  }
}

customElements.define('search-form', SearchForm);
